import { useEffect, useMemo, useState } from 'react';
import chunk from 'lodash/chunk';

function useChunked(nodes, { chunkSize, pageIndex = 0, isChunked = true } = {}) {
  const chunkedNodes = useMemo(() => chunk(nodes, chunkSize), [
    nodes,
    chunkSize,
  ]);
  const [ currentNodes, setNodes ] = useState( isChunked ? chunkedNodes[ 0 ] : nodes );
  const hasMore = pageIndex < chunkedNodes.length - 1;

  useEffect(() => {
    if (isChunked && !!chunkedNodes.length) {
      setNodes(chunkedNodes.slice(0, pageIndex + 1).flat());
    } else {
      setNodes(nodes);
    }
  }, [ nodes, pageIndex, chunkedNodes, isChunked ]);

  return {
    currentNodes,
    hasMore
  }
}

export default useChunked;
